import axiosInstance from "../services/axiosComman";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useQueryClient } from "@tanstack/react-query";

function useDeleteMaster() {
  const queryClient = useQueryClient();
  const deleteMaster = async ({
    url,
    name,
    value,
    getData = () => {}
  }) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to Delete ${name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.post(url, value);

          const successMessage = response.data.msg || response.data.message || "Data Deleted successfully";
          const isSuccess = response.data.status || successMessage === "Data Deleted Successfully";

          if (isSuccess) {
            getData();
            toast.success(<p className="text-sm">{successMessage}</p>);
            queryClient.invalidateQueries({ queryKey: ["alerts"] });
          } else {
            const errorMessage = response.data.msg || response.data.message || "Failed to delete data";
            toast.error(<p className="text-sm">{errorMessage}</p>);
          }
        } catch (error) {
          if (!error.response) {
            toast.error(
              <p className="text-sm">
                {`CORS Error: Unable to connect to the server. Please check server CORS settings.`}
              </p>
            );
          } else {
            const errorMessage =
              error.response.data?.msg ||
              error.response.data?.message ||
              error.response.data?.error ||
              "An unexpected error occurred";
            toast.error(<p className="text-sm">{errorMessage}</p>);
          }
        }
      }
    });
  };
  return { deleteMaster };
}

export default useDeleteMaster;